import { render, staticRenderFns } from "./AssociatedAccountComponent.vue?vue&type=template&id=2842f8a9&scoped=true"
import script from "./AssociatedAccountComponent.vue?vue&type=script&lang=js"
export * from "./AssociatedAccountComponent.vue?vue&type=script&lang=js"
import style0 from "./AssociatedAccountComponent.vue?vue&type=style&index=0&id=2842f8a9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2842f8a9",
  null
  
)

export default component.exports